<light-layout>
  <div class="__page-root">
    <hero name="Scala Architecture Migration" kicker>
      <div class="cover-image hero-background tinted"></div>
      <back-to-button></back-to-button>
    </hero>
    <div class="sections">
      <app-summary color="#426EFF"
                   content="Our Client, a Credit Union, was invested in Legacy systems with zero test coverage, in a tightly coupled Microsoft infrastructure which was difficult to scale and maintain. Its web interface was buggy and not mobile enabled.">
        <role [style.width.%]="100">
          <li>Scala</li>
          <li>Akka</li>
          <li>Docker</li>
          <li>Ansible</li>
          <li>AWS</li>
          <li>ElasticSearch</li>
          <li>CI/CD</li>
          <li>Mobility</li>
          <li>UI/UX/li></li>
        </role>
      </app-summary>

      <challenge color="#426EFF"
                     content="Data Concepts’ mission was to deliver high quality, scalable code and architecture that was easy to extend and maintain. Test coverage and infrastructure automation were two of the most important goals."></challenge>

      <solution-header content="seamless migration to scala microservices"></solution-header>

      <solution>
        <p>We developed the client’s vision for a beautiful web interface by first resolving the underlying issues. Data concepts identified Scala Micro Services as the best platform, and the migration to Scala served as the foundation for an architectural transformation that solidly supported test coverage and automated deployment.</p>
        <ul class="pseudo">
          <li>- New responsive web front-end, developed in a “mobile-first” spirit.</li>
          <li>- Highly scalable API bridge that provides consistent and uniform REST API and makes further migration to Scala micro services fully transparent.</li>
          <li>- Mobile-aware, WYSIWYG CMS.</li>
          <li>- Automated deployment.</li>
        </ul>
      </solution>

      <outcome color="#426EFF"
                   content="To ensure our client was able to maximize their investment, the system was set up to avoid “vendor lock-in” and our consultants collaborated to train the client’s in-house dev team. Due to automated tests coverage and zero-downtime Continuous Delivery, coupled with the advantages of applying git-flow patterns, deployments became a matter of formality."></outcome>
    </div>
  </div>
</light-layout>
